/*
    This API file is currently just hard-coded stubs, 
    meant to simulate API data. Task #22334 will 
    properly connect these stubs to the API, once the 
    API has been fully built out
*/

import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import { PaginatedResponse } from '../../../shared/types/pagination';
import { AddIncidentFormValues } from '../../features/IncidentForm/AddIncidentForm';
import {
  Account,
  CareDriverRecord,
  IncidentClassification,
  IncidentSubclassification,
  Rider,
} from '../../types/incidents';

export function getAllSafetyIncidents(query) {
  return requestWithQuery({ url: 'care/safety_incidents', params: query, method: 'GET' });
}

export function getSafetyIncident(id: number) {
  return requestWithQuery({ url: 'care/safety_incidents/' + id, method: 'GET' });
}

export function getTripRelations(id: string | number | null) {
  if (id) {
    return requestWithQuery({ url: 'care/safety_incidents/trips/' + id, method: 'GET' });
  }

  return null;
}

export function getOffenderTypes() {
  return requestWithQuery({ url: 'care/safety_incidents/offender_types', method: 'GET' });
}

export function getStatuses() {
  return requestWithQuery({ url: 'care/safety_incidents/statuses', method: 'GET' });
}

export function getActions() {
  return requestWithQuery({ url: 'care/safety_incidents/actions', method: 'GET' });
}

export function getClassifications(query) {
  return requestWithQuery<PaginatedResponse<IncidentClassification>>({
    url: 'care/safety_incidents_classifications',
    params: query,
    method: 'GET',
  });
}
export function getSubClassifications(query) {
  return requestWithQuery<PaginatedResponse<IncidentSubclassification>>({
    url: 'care/safety_incidents_subclassifications',
    params: query,
    method: 'GET',
  });
}

export function postAdminNote(id: number, content: string) {
  return requestWithQuery({
    url: 'care/safety_incidents/' + id + '/admin_notes',
    data: { content: content },
    method: 'POST',
  });
}

export function postIncident(data: AddIncidentFormValues) {
  return requestWithQuery({ url: 'care/safety_incidents', method: 'POST', data: data });
}

export function patchIncident(id: number, data) {
  return requestWithQuery({ url: 'care/safety_incidents/' + id, method: 'PATCH', data: data });
}

export function deleteIncident(id: number) {
  return requestWithQuery({ url: 'care/safety_incidents/' + id, method: 'DELETE' });
}

// TODO: Maybe move these to another file, since they're not in the safety-incidents namespace
export function getAllAssignees(query) {
  return requestWithQuery({ url: 'care/employees', params: query, method: 'GET' });
}

export async function getAccounts(query): Promise<ApiResponse<Account>> {
  return requestWithQuery({ url: 'care/accounts', params: query, method: 'GET' });
}

export async function getRiders(query): Promise<ApiResponse<Rider>> {
  return requestWithQuery({ url: 'care/riders', params: query, method: 'GET' });
}

export async function getCareDrivers(query): Promise<ApiResponse<CareDriverRecord[]>> {
  return requestWithQuery({ url: 'care/drivers', params: query, method: 'GET' });
}

// TODO: In the future replace this with an API call if we create one
export function getFollowupTypes() {
  const followupTypes = [
    { label: 'CareDriver', value: 'driver' },
    { label: 'Organizer', value: 'organizer' },
    { label: 'Client', value: 'client' },
    { label: 'Caregiver', value: 'caregiver' },
  ];

  return Promise.resolve(followupTypes);
}
